(function () {

  const desktopMedia = window.matchMedia('(min-width: 990px)');
  const closeTimers = new WeakMap();


  /* =========================================
     关闭一个 Mega Menu
     ========================================= */
  function closeMenu(menuItem) {

    if (!menuItem) return;

    const menuHeader = menuItem.querySelector(':scope > sht-menu-header');
    if (!menuHeader) return;

    const details = menuHeader.querySelector(':scope > details');
    if (!details) return;

    const summary = details.querySelector(':scope > summary');
    const header = menuItem.closest('sht-header');

    clearTimeout(closeTimers.get(details));

    details.classList.remove('is-open');

    if (header) {
      header.classList.remove('header-menu--open');
    }

    if (summary) {
      summary.setAttribute('aria-expanded', 'false');
    }

    /*
      与 Electro 原来的关闭动画保持一致
    */
    const timer = setTimeout(function () {
      details.removeAttribute('open');
    }, 100);

    closeTimers.set(details, timer);
  }


  /* =========================================
     关闭其他一级 Mega Menu
     ========================================= */
  function closeOtherMenus(currentMenuItem) {

    document
      .querySelectorAll('.header__nav .main__menu > .menu__item')
      .forEach(function (item) {

        if (item === currentMenuItem) return;

        const dropdown = item.querySelector('.lumo-mega-dropdown');

        if (!dropdown) return;

        closeMenu(item);

      });

  }


  /* =========================================
     打开一级 Mega Menu
     ========================================= */
  function openMenu(menuItem) {

    if (!desktopMedia.matches) return;
    if (!menuItem) return;

    const menuHeader = menuItem.querySelector(':scope > sht-menu-header');
    if (!menuHeader) return;

    const details = menuHeader.querySelector(':scope > details');
    if (!details) return;

    const dropdown = details.querySelector('.lumo-mega-dropdown');

    /*
      只控制我们自己创建的 Mega Menu
    */
    if (!dropdown) return;

    const summary = details.querySelector(':scope > summary');
    const header = menuItem.closest('sht-header');

    clearTimeout(closeTimers.get(details));

    /*
      先关闭 LED / LCD / Portable 中其他已经打开的菜单
    */
    closeOtherMenus(menuItem);

    /*
      完整模拟 Electro 原生打开状态
    */
    details.setAttribute('open', '');

    if (summary) {
      summary.setAttribute('aria-expanded', 'true');
    }

    if (header) {
      header.classList.add('header-menu--open');
    }

    /*
      Electro 自己也是稍后增加 is-open
    */
    requestAnimationFrame(function () {
      details.classList.add('is-open');
    });
  }


  /* =========================================
     一级目录 Hover 打开
     ========================================= */
  document.addEventListener('mouseover', function (event) {

    if (!desktopMedia.matches) return;

    const menuItem = event.target.closest(
      '.header__nav .main__menu > .menu__item'
    );

    if (!menuItem) return;

    const dropdown = menuItem.querySelector('.lumo-mega-dropdown');

    if (!dropdown) return;


    /*
      如果只是在当前菜单内部移动，不重复打开
    */
    if (
      event.relatedTarget &&
      menuItem.contains(event.relatedTarget)
    ) {
      return;
    }

    openMenu(menuItem);

  });


  /* =========================================
     鼠标离开整个菜单后自动关闭
     ========================================= */
  document.addEventListener('mouseout', function (event) {

    if (!desktopMedia.matches) return;

    const menuItem = event.target.closest(
      '.header__nav .main__menu > .menu__item'
    );

    if (!menuItem) return;

    const dropdown = menuItem.querySelector('.lumo-mega-dropdown');

    if (!dropdown) return;


    /*
      从一级标题移动到下拉菜单内部时
      不关闭
    */
    if (
      event.relatedTarget &&
      menuItem.contains(event.relatedTarget)
    ) {
      return;
    }


    const menuHeader = menuItem.querySelector(':scope > sht-menu-header');

    if (!menuHeader) return;

    const details = menuHeader.querySelector(':scope > details');

    if (!details) return;


    clearTimeout(closeTimers.get(details));


    /*
      留一点缓冲时间，避免鼠标往下移动时闪退
    */
    const timer = setTimeout(function () {

      /*
        再确认一次鼠标是否仍然在菜单内部
      */
      if (!menuItem.matches(':hover')) {
        closeMenu(menuItem);
      }

    }, 180);

    closeTimers.set(details, timer);

  });



  /* =========================================
     禁止桌面端点击 Summary 再切换开/关
     手机端仍然保持 Electro 原来的点击方式
     ========================================= */
  document.addEventListener(
    'click',
    function (event) {

      if (!desktopMedia.matches) return;

      const summary = event.target.closest(
        '.header__nav .main__menu > .menu__item > sht-menu-header > details > summary'
      );

      if (!summary) return;

      const details = summary.closest('details');

      if (!details) return;

      const dropdown = details.querySelector('.lumo-mega-dropdown');

      if (!dropdown) return;

      /*
        阻止 Electro 原来的：
        点击一次打开、再点击一次关闭
      */
      event.preventDefault();
      event.stopImmediatePropagation();

      const menuItem = summary.closest('.menu__item');

      openMenu(menuItem);

    },
    true
  );



  /* =========================================
     左侧系列 Hover
     切换右侧 Collection 产品
     ========================================= */
  document.addEventListener('mouseover', function (event) {

    if (!desktopMedia.matches) return;

    const trigger = event.target.closest(
      '[data-lumo-mega-trigger]'
    );

    if (!trigger) return;


    if (
      event.relatedTarget &&
      trigger.contains(event.relatedTarget)
    ) {
      return;
    }


    const megaMenu = trigger.closest(
      '[data-lumo-mega-menu]'
    );

    if (!megaMenu) return;


    const targetId = trigger.getAttribute(
      'data-lumo-mega-trigger'
    );


    /*
      左侧取消高亮
    */
    megaMenu
      .querySelectorAll('[data-lumo-mega-trigger]')
      .forEach(function (item) {
        item.classList.remove('is-active');
      });


    /*
      右侧全部隐藏
    */
    megaMenu
      .querySelectorAll('[data-lumo-mega-panel]')
      .forEach(function (panel) {
        panel.classList.remove('is-active');
      });


    /*
      当前系列高亮
    */
    trigger.classList.add('is-active');


    /*
      显示对应产品
    */
    const panel = megaMenu.querySelector(
      '[data-lumo-mega-panel="' + targetId + '"]'
    );

    if (panel) {
      panel.classList.add('is-active');
    }

  });



  /* =========================================
     ESC 关闭
     ========================================= */
  document.addEventListener('keydown', function (event) {

    if (event.key !== 'Escape') return;

    document
      .querySelectorAll(
        '.header__nav .main__menu > .menu__item'
      )
      .forEach(function (item) {

        if (item.querySelector('.lumo-mega-dropdown')) {
          closeMenu(item);
        }

      });

  });

})();